import * as Account from '../util/Account';

export default (to, from, next) => {
	if (!Account.isAuthenticated() && to.path !== '/login') {
		next('/login');
	} else if (to.matched.length <= 0) {
		next('/analytics');
	} else if (to.matched.length > 0) {
		next();
	}
};
